import React, {useState, useEffect} from 'react';
import './Header.css';
import '../../public/assets/styles/generic.css';
import '../../public/assets/styles/specific.css';
import '../../public/assets/styles/responsive/mobile.css';
import '../../public/assets/styles/responsive/desktop.css';
import '../../public/assets/styles/responsive/tablet.css';
import toast, { Toaster } from 'react-hot-toast';

import {Phone} from '@phosphor-icons/react'
import Search from '../Search/Search';
import Cart from '../Cart/Cart';
import Dropdown from '../Dropdown/Dropdown';
import config from '../../../../config';

const Header = (props) => {
    
    const [top, setTop] = useState(true);
    const [lastScroll, setLastScroll] = useState();

    useEffect(() => {
        const updateScrollTop = () => {
            const scrollY = window.pageYOffset;
            setTop(scrollY < 50);
            setLastScroll(window.pageYOffset);
        };

        window.addEventListener("scroll", updateScrollTop); // add event listener

        return () => {
            window.removeEventListener("scroll", updateScrollTop); // clean up
        }
    },[lastScroll]);

    const [mobileActive, setMobileActive] = useState(false);

    function toggleMobileMenu() {
        setMobileActive(!mobileActive);
    }

    const [show, setShow] = useState(true);
    const [lastScrollY, setLastScrollY] = useState(0);
    
    const controlNavbar = () => {
        if (typeof window !== 'undefined') { 
        if (window.scrollY > lastScrollY) { // if scroll down hide the navbar
            setShow(false); 
        } else { // if scroll up show the navbar
            setShow(true);  
        }
    
        // remember current page location to use in the next move
        setLastScrollY(window.scrollY); 
        }
    };
    
    useEffect(() => {
        if (typeof window !== 'undefined') {
        window.addEventListener('scroll', controlNavbar);
    
        // cleanup function
        return () => {
            window.removeEventListener('scroll', controlNavbar);
        };
        }
    }, [lastScrollY]);

    return (
        <div className="Header">
            <div><Toaster/></div>

            <div className={`mobile MobileHeader ${(show || mobileActive) ? 'enable' : ''}`}>
                {/* <div className="christmas-banner">
                    <p className='marquee'>
                        <span>ABC Container Hire & Sales is closed for Christmas starting on the 21st of December and returning on the 6th of January.</span>
                    </p>
                </div> */}
                <div className={`MobileHeaderTop w-100 bg-light`}>
                    <div className="w-90 h-100 d-flex space-between justify-center align-center">
                        <div className={`Sandwich ${mobileActive && 'active'}`} onClick={()=>toggleMobileMenu()}>
                            <div className="bar bar1" />
                            <div className="bar bar2" />
                            <div className="bar bar3" />
                        </div>
                        <div className="Spacer10px"></div>
                        <div className="Spacer10px"></div>
                        <a href="https://www.abcchs.com.au" className='d-flex align-center'><img src="/assets/img/ABCLogo_Simple.png" style={{height: 40}} alt="Home Page | ABC CHS" /></a>
                        <div className="Spacer10px"></div>
                        <div className="Spacer10px"></div>
                        <div className='d-flex align-center MobileFixedWidth space-between'>
                            <Cart />
                            <div className="Spacer10px"></div>
                            <div className="Spacer10px"></div>
                            <a href={"tel:" + config.tel} className='phone' aria-label="Phone">
                                <Phone size={30} color="#2271b3" />
                            </a>
                        </div>
                    </div>
                </div>
                <div className={`MobileMenu ${!mobileActive && 'inactive'}`}>
                    <div className="w-90">
                        <h4 className='bold no-block-end'>Navigation</h4>
                        <div className="line w-100 bg-main"></div>
                        <br />
                        <ul className='arrows'>
                            <li> <a href="https://www.abcchs.com.au/" className='color-dark no-style'>Home</a> </li>
                            <li> <a href="https://www.abcchs.com.au/shipping-containers-for-sale" className='color-dark no-style'>Buy</a></li>
                            <li> <a href="https://www.abcchs.com.au/hire" className='color-dark no-style'>Hire</a></li>
                            <li> <a href="https://www.abcchs.com.au/removals" className='color-dark no-style'>Removals</a></li>
                            <li> <a href="https://www.abcchs.com.au/news" className='color-dark no-style'>News & Articles</a> </li>
                            <li> <a href="https://www.abcchs.com.au/contact" className='color-dark no-style'>Contact Us</a> </li>
                            <li> <a href="https://www.abcchs.com.au/about" className='color-dark no-style'>About</a> </li>
                            <li> <a href="https://www.abcchs.com.au/mod-quote" className="color-dark no-style">Modifications</a></li>
                            <li> <a href="https://www.abcchs.com.au/stock-clearout" className="color-dark no-style">Stock Clearout</a></li>
                            <li> <a href="/" className="color-dark no-style">Online Store</a></li>
                        </ul>
                        <br /><br /><br />
                    </div>
                </div>
            </div>

            <div className="desktop">
                {/* <div className="christmas-banner">
                    <p>
                        <span>ABC Container Hire & Sales is closed for Christmas starting on the 21st of December and returning on the 6th of January.</span>
                    </p>
                </div> */}
                <div className={`TopHeader bg-main w-100 ${!top && 'small'}`}>
                    <div className="d-flex row w-90 space-between align-center h-100">
                        <div className="d-flex col flex-1">
                            <a href="https://www.abcchs.com.au">
                                {/* <img src="/assets/img/ABCLong-Xmas.gif" className="xmas-abc-logo" alt="ABC CHS" /> */}
                                <img src="/assets/img/abclong.svg" alt="ABC CHS" />
                            </a>
                        </div>
                        <div className="d-flex row flex-2 ">
                            <div className="w-90 d-flex row space-around">
                                <a href="https://www.abcchs.com.au/" className="color-light">Home</a>
                                <a href="https://www.abcchs.com.au/shipping-containers-for-sale" className="color-light">Buy</a>
                                <a href="https://www.abcchs.com.au/hire" className="color-light">Hire</a>
                                <a href="https://www.abcchs.com.au/mod-quote" className="color-light">Modifications</a>
                                <a href="https://www.abcchs.com.au/removals" className="color-light">Removals</a>
                                <a href="https://www.abcchs.com.au/stock-clearout" className="color-light">Stock Clearout</a>
                                <a href="/" className="color-light">Online Store</a>
                            </div>
                        </div>
                        <div className="d-flex col flex-1 justify-right"><h4>"<b>A</b>ustralia's <b>B</b>est <b>C</b>ontainers"</h4></div>
                    </div>
                </div>
                <div className={`BottomHeader bg-light flex row w-100 ${!top && 'small'}`}>
                    <div className="d-flex row w-90 space-between align-center h-100">
                        <div className="d-flex row flex-1">
                            <a href={"tel:" + config.tel} className="no-style">
                                <h5 className='d-flex row align-center'><Phone size={30} />{config.tel_text}</h5>
                            </a>
                        </div>
                        <div className="d-flex row flex-3 space-around non-selectable">
                            <div className='d-flex align-center'>
                                <a href="/?size=10%20foot" class="menuLink">10ft Containers</a>
                            </div>
                            <div className='d-flex align-center'>
                                <a href="/?size=20%20foot" class="menuLink">20ft Containers</a>
                            </div>
                            <div className='d-flex align-center'>
                                <a href="/?size=40%20foot" class="menuLink">40ft Containers</a>
                            </div>
                            {/* <div className='d-flex align-center'>
                                <Dropdown title="Locations">
                                    <ul className="dropdown-ul">
                                        <li>
                                            <Dropdown title="Toowoomba" link="/toowoomba">
                                                <ul>
                                                    <a href="/toowoomba/10ft"><li>10ft Containers</li></a>
                                                    <a href="/toowoomba/20ft"><li>20ft Containers</li></a>
                                                    <a href="/toowoomba/40ft"><li>40ft Containers</li></a>
                                                </ul>
                                            </Dropdown>
                                        </li>
                                        <li>
                                            <Dropdown title="Brisbane" link="/brisbane">
                                                <ul>
                                                    <a href="/brisbane/10ft"><li>10ft Containers</li></a>
                                                    <a href="/brisbane/20ft"><li>20ft Containers</li></a>
                                                    <a href="/brisbane/40ft"><li>40ft Containers</li></a>
                                                </ul>
                                            </Dropdown>
                                        </li>
                                        <li>
                                            <Dropdown title="Gold Coast" link="/gold-coast">
                                                <ul>
                                                    <a href="/gold-coast/10ft"><li>10ft Containers</li></a>
                                                    <a href="/gold-coast/20ft"><li>20ft Containers</li></a>
                                                    <a href="/gold-coast/40ft"><li>40ft Containers</li></a>
                                                </ul>
                                            </Dropdown>
                                        </li>
                                        <li>
                                            <Dropdown title="Sunshine Coast" link="/sunshine-coast">
                                                <ul>
                                                    <a href="/sunshine-coast/10ft"><li>10ft Containers</li></a>
                                                    <a href="/sunshine-coast/20ft"><li>20ft Containers</li></a>
                                                    <a href="/sunshine-coast/40ft"><li>40ft Containers</li></a>
                                                </ul>
                                            </Dropdown>
                                        </li>
                                        <li>
                                            <Dropdown title="Gympie" link="/gympie">
                                                <ul>
                                                    <a href="/gympie/10ft"><li>10ft Containers</li></a>
                                                    <a href="/gympie/20ft"><li>20ft Containers</li></a>
                                                    <a href="/gympie/40ft"><li>40ft Containers</li></a>
                                                </ul>
                                            </Dropdown>
                                        </li>
                                        <li>
                                            <Dropdown title="Lismore" link="/lismore">
                                                <ul>
                                                    <a href="/lismore/10ft"><li>10ft Containers</li></a>
                                                    <a href="/lismore/20ft"><li>20ft Containers</li></a>
                                                    <a href="/lismore/40ft"><li>40ft Containers</li></a>
                                                </ul>
                                            </Dropdown>
                                        </li>
                                        <li>
                                            <Dropdown title="Cairns" link="/cairns">
                                                <ul>
                                                    <a href="/cairns/10ft"><li>10ft Containers</li></a>
                                                    <a href="/cairns/20ft"><li>20ft Containers</li></a>
                                                    <a href="/cairns/40ft"><li>40ft Containers</li></a>
                                                </ul>
                                            </Dropdown>
                                        </li>
                                        <li>
                                            <Dropdown title="Townsville" link="/townsville">
                                                <ul>
                                                    <a href="/townsville/10ft"><li>10ft Containers</li></a>
                                                    <a href="/townsville/20ft"><li>20ft Containers</li></a>
                                                    <a href="/townsville/40ft"><li>40ft Containers</li></a>
                                                </ul>
                                            </Dropdown>
                                        </li>
                                        <li>
                                            <Dropdown title="Mackay" link="/mackay">
                                                <ul>
                                                    <a href="/mackay/10ft"><li>10ft Containers</li></a>
                                                    <a href="/mackay/20ft"><li>20ft Containers</li></a>
                                                    <a href="/mackay/40ft"><li>40ft Containers</li></a>
                                                </ul>
                                            </Dropdown>
                                        </li>
                                        <li>
                                            <Dropdown title="Rockhampton" link="/rockhampton">
                                                <ul>
                                                    <a href="/rockhampton/10ft"><li>10ft Containers</li></a>
                                                    <a href="/rockhampton/20ft"><li>20ft Containers</li></a>
                                                    <a href="/rockhampton/40ft"><li>40ft Containers</li></a>
                                                </ul>
                                            </Dropdown>
                                        </li>
                                        <li>
                                            <Dropdown title="Gladstone" link="/gladstone">
                                                <ul>
                                                    <a href="/gladstone/10ft"><li>10ft Containers</li></a>
                                                    <a href="/gladstone/20ft"><li>20ft Containers</li></a>
                                                    <a href="/gladstone/40ft"><li>40ft Containers</li></a>
                                                </ul>
                                            </Dropdown>
                                        </li>
                                        <li>
                                            <Dropdown title="Bundaberg" link="/bundaberg">
                                                <ul>
                                                    <a href="/bundaberg/10ft"><li>10ft Containers</li></a>
                                                    <a href="/bundaberg/20ft"><li>20ft Containers</li></a>
                                                    <a href="/bundaberg/40ft"><li>40ft Containers</li></a>
                                                </ul>
                                            </Dropdown>
                                        </li>
                                        <li>
                                            <Dropdown title="Warwick" link="/warwick">
                                                <ul>
                                                    <a href="/warwick/10ft"><li>10ft Containers</li></a>
                                                    <a href="/warwick/20ft"><li>20ft Containers</li></a>
                                                    <a href="/warwick/40ft"><li>40ft Containers</li></a>
                                                </ul>
                                            </Dropdown>
                                        </li>
                                        <li>
                                            <Dropdown title="Grafton" link="/grafton">
                                                <ul>
                                                    <a href="/grafton/10ft"><li>10ft Containers</li></a>
                                                    <a href="/grafton/20ft"><li>20ft Containers</li></a>
                                                    <a href="/grafton/40ft"><li>40ft Containers</li></a>
                                                </ul>
                                            </Dropdown>
                                        </li>
                                    </ul>
                                </Dropdown>
                            </div> */}
                        </div>
                        <div className="d-flex row flex-1 justify-right">
                            <Search />
                            <Cart />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Header;